var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgProvider = function SvgProvider(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 10,
    "data-width-16": 12,
    "data-width-20": 15,
    "data-width-24": 18,
    "data-width-28": 21,
    viewBox: "0 0 10 11.1",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M3.367 3.12H1.75M4.06 1.273V.438M4.982 3.58h.503c.417 0 .818-.166 1.113-.46H7.75c0-1.528-.577-2.77-2.769-2.77s-2.77 1.242-2.77 2.77h1.155c.295.294.695.46 1.112.46z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M7.29 3.12v.46a2.308 2.308 0 1 1-4.616 0v-.46M6.598 3.12h1.615M5.905 1.273V.438"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.537 11.177H.427a.47.47 0 0 1-.3-.111.36.36 0 0 1-.127-.264C.002 9.774.467 8.79 1.294 8.063s1.949-1.135 3.119-1.136H5.55c1.17.001 2.292.41 3.119 1.136.827.727 1.292 1.711 1.294 2.739a.36.36 0 0 1-.127.264.47.47 0 0 1-.3.11m-8.66-.75h8.21c-.108-.758-.526-1.455-1.177-1.96a3.87 3.87 0 0 0-2.359-.79H4.413a3.87 3.87 0 0 0-2.359.79c-.65.505-1.07 1.202-1.177 1.96"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProvider);
export default ForwardRef;